import React from "react";
import {
  makeStyles,
  createStyles,
  Box,
  Tabs,
  Tab,
  Theme,
} from "@material-ui/core";
import { Sidebar, PageHeadDiv, PageBodyDiv } from "../../components";
import { FileCrawlingContainer } from "./filecrawling/FileCrawlingContainer";
import { WebCrawlingContainer } from "./webcrawling/WebCrawlingContainer";

/** タブペイン プロップ */
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

/** タブペイン コンポーネント */
function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      style={{ width: "100%" }}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      backgroundColor: "cyan",
    },
    bodySubcontainer: {
      display: "flex",
      height: "100%",
    },
    tabs: {
      borderRight: `1px solid ${theme.palette.divider}`,
      backgroundColor: "white",
    },
  })
);

/** 通知ページ */
export function NotificationPage() {
  const classes = useStyles();

  //------------------------------
  // tabメニュー
  // [State]
  const [tabValue, setTabValue] = React.useState(0);
  // [Handler]
  const handleTabChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  //--------------------
  // コンポーネント
  return (
    <div className="main-container">
      <div className="left-container">
        <Sidebar />
      </div>
      <div className="right-container">
        <PageHeadDiv title="通知" />
        <PageBodyDiv>
          <div className={classes.bodySubcontainer}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={tabValue}
              onChange={handleTabChange}
              aria-label="Vertical tabs example"
              className={classes.tabs}
            >
              <Tab
                label="Fileクロール"
                id="vertical-tab-0"
                aria-controls="vertical-tabpanel-0"
              />
              <Tab
                label="Webクロール"
                id="vertical-tab-1"
                aria-controls="vertical-tabpanel-1"
              />
            </Tabs>
            <TabPanel value={tabValue} index={0}>
              <FileCrawlingContainer />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <WebCrawlingContainer />
            </TabPanel>
          </div>
        </PageBodyDiv>
      </div>
    </div>
  );
}
